import { useEffect, useState } from "react";

const REQUETE = "(prefers-reduced-motion: reduce)";

const lire = (): boolean => typeof window.matchMedia === "function" && window.matchMedia(REQUETE).matches;

/**
 * `prefers-reduced-motion`, SUIVI : le visiteur peut changer son réglage système
 * pendant que la page est ouverte, et une lecture unique au montage ne le verrait
 * pas. Les animations d'entrée de l'accueil en dépendent (voir `SplashScreen`).
 */
export function useReducedMotion(): boolean {
  const [reduit, setReduit] = useState(lire);

  useEffect(() => {
    if (typeof window.matchMedia !== "function") return;
    const media = window.matchMedia(REQUETE);
    const onChange = () => setReduit(media.matches);
    media.addEventListener("change", onChange);
    return () => media.removeEventListener("change", onChange);
  }, []);

  return reduit;
}
